import { NavigationIcon } from '@tymbe/ui-icons';
import Modal from 'react-modal';
import { ComponentProps, useState } from 'react';
import Menu from './Menu';

type HamburgerProps = ComponentProps<'div'>;

const Hamburger = (props: HamburgerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div {...props}>
      <NavigationIcon name="menu" className="absolute right-4 top-6 size-5 cursor-pointer z-10" onClick={() => setIsOpen(true)} />
      <Modal isOpen={isOpen} className="test @container overflow-auto flex flex-col h-screen bg-secondary-50" portalClassName="relative z-modal">
        <NavigationIcon name="menu_open" className="absolute right-4 top-6 size-5 cursor-pointer z-modal" onClick={() => setIsOpen(false)} />
        <Menu onClick={() => setIsOpen(false)} />
      </Modal>
    </div>
  );
};

export default Hamburger;
